<template>
  <div class="innovation">
    <p>
      We truly believe that drivers like you are unique by every measure. So is
      the vehicle you take pride in. From classic
      <span style="white-space: nowrap;">Porsche</span> models to the latest EVs
      and hybrid marvels, you and your family deserve protection optimized to
      your lifestyle.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HomepageInnovation'
};
</script>

<style lang="scss" scoped>
p {
  font-size: 16px;
  line-height: 20px;
}
.innovation {
  @media (min-width: 1000px) {
    padding-right: 20%;
  }

  p:first-of-type {
    margin-top: 0;
  }
}

.subtitle {
  font-family: $family-sans-serif-thin;
  margin-bottom: 36px;
}

ul {
  margin-top: 2rem;
  margin-left: 0px !important;
  @media (min-width: 1200px) {
    columns: 2;
  }
}

li {
  margin-bottom: 1rem;
}
</style>
